import React, { Component } from "react";
import ErrorIcon from "@mui/icons-material/Error";

class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportsSelected: 0,
      processModalOpen: false,
      reportArr: [],
      patientData: [],
      patientDataLoading: true,
      fullPatientData: [],
      showFilters: true,
    };
  }

  render() {
    const { message } = this.props;
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ErrorIcon /> <span style={{ marginLeft: "10px" }}>{message}</span>
      </div>
    );
  }
}

export default Alert;
